import { IProductDefinition } from '@ads/front-core/products/IProductDefinition'
import { Eye } from '@ads/front-core/Icons/wizard'
import { lng } from '@ads/front-core/locales'
import limits from '@ads/front-core/constants/limits'
import { ProductFor, WizardSubCategoryEnum } from '@ads/front-core/interfaces'
import { campaignMaxDateByDays } from './utils'

export const OUTSTREAM_VIDEO_CPM: IProductDefinition = {
  productTypeId: 'OUTSTREAM_VIDEO_CPM',
  productAvailableFor: [ProductFor.NONPUBLISHER],
  createUrl: '/campaign/create/outstream-in-banner-cpm/',
  title: 'campaign:outstreamInBanner.title',
  titleForAdmin: 'Video outstream in-banner (CPM)',
  budget: {
    model: 'CPM',
    type: 'TOTAL',
    variant: 'ANY',
    disableDailyLimit: true,
    validation: {
      globalLimit: {
        min: limits.OUTSTREAM_IN_BANNER_MIN_TOTAL,
      },
      rate: {
        min: limits.OUTSTREAM_IN_BANNER_MIN_RATE_CPM,
        max: limits.MAXIMUM_RATE_CPM,
      },
    },
  },
  campaignMinimumRates: {
    fields: ['DEFAULT'],
    inputType: 'currency',
  },
  campaignMaxDate: campaignMaxDateByDays(90),
  allowedCreationTypes: ['OUTSTREAM_VIDEO'],
  creationsDescription: {
    description: 'campaign:outstreamInBanner.creations.titleDescription',
  },
  targeting: {
    countries: true,
    demography: true,
    devices: true,
    locations: true,
    emitToTrusted: true,
    segmentsTab: ['segments', 'retargetingSegments'],
  },
  wizard: {
    subCategory: WizardSubCategoryEnum.OUTSTREAM_IN_BANNER,
    productDescription: {
      title: lng('campaign:views'),
      description: lng('wizard:displayCPMDescription'),
      Icon: Eye,
    },
    parameters: [
      {
        label: lng('campaign:billingModel'),
        value: lng('wizard:budgetModel.cpm'),
      },
      {
        label: lng('wizard:destination'),
        value: lng('wizard:buildingAwarenessReach'),
      },
    ],
  },
}
